module.exports = __webpack_public_path__ + "static/media/acgres.c891aa21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/acgres.jpg
// module id = 1043
// module chunks = 0